import { GET_MODALITY_TYPES_SUCCESS } from '../../constants/ActionTypes';

const INIT_STATE = []
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_MODALITY_TYPES_SUCCESS: {
            return action.modalityTypes;
        }

        default:
            return state;
    }
}